import axios from "axios";
import { Documents_Master_Service_URL, Partner_Service_URL } from "../Url";

export const saveRUCInfoActions = {
  SAVE_RUC_INFO_EDITPARTNER_SUCCESS: "SAVE_RUC_INFO_EDITPARTNER_SUCCESS",
  SAVE_RUC_INFO_EDITPARTNER_ERROR: "SAVE_RUC_INFO_EDITPARTNER_ERROR",
};

export function saveRcuInfoDetails(props) {
  const { access_token, values, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/savePartnerRcuInfo?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveRcuInfoApplicantDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveRcuInfoApplicantDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveRcuInfoApplicantDetailsError(err));
          return err.response;
        }
      });
}

export function saveRcuInfoApplicantDetailsError(error) {
  return {
    type: saveRUCInfoActions.SAVE_RUC_INFO_EDITPARTNER_ERROR,
    payload: error,
  };
}

export function saveRcuInfoApplicantDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveRUCInfoActions.SAVE_RUC_INFO_EDITPARTNER_SUCCESS,
      payload: props,
    });
  };
}


export const getESignActions = {
  GET_ESIGN_DATA_SUCCESS: "GET_ESIGN_DATA_SUCCESS",
  GET_ESIGN_DATA_ERROR: "GET_ESIGN_DATA_ERROR",
};

export function getESignDetails(props) {
  const { access_token, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getPartnerEsignDetails?partnerFirmId=${partnerFirmId}`,

    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getESignSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getESignError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getESignError(err));
          return err.response;
        }
      });
}

export function getESignError(error) {
  return {
    type: getESignActions.GET_ESIGN_DATA_ERROR,
    payload: error,
  };
}

export function getESignSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getESignActions.GET_ESIGN_DATA_SUCCESS,
      payload: props,
    });
  };
}



export const saveESignActions = {
  SAVE_ESIGN_TIGGER_SUCCESS: "SAVE_ESIGN_SAVE_ESIGN_TIGGER_SUCCESS",
  SAVE_ESIGN_TIGGER_ERROR: "SAVE_ESIGN_TIGGER_ERROR",
};

export function saveESignTiggerDetails(props) {
  const { access_token, values, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/triggerEsign?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveESignTiggerSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveESignTiggerError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveESignTiggerError(err));
          return err.response;
        }
      });
}

export function saveESignTiggerError(error) {
  return {
    type: saveESignActions.SAVE_ESIGN_TIGGER_ERROR,
    payload: error,
  };
}

export function saveESignTiggerSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveESignActions.SAVE_ESIGN_TIGGER_SUCCESS,
      payload: props,
    });
  };
}



export const getEsignDocument = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;

  return axios({
    method: "post",
    url: `${Documents_Master_Service_URL}/get/eSignDocument/ByPartnerFirmId`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {

        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);

        throw error;
      }
    })
    .catch((error) => {

      throw error;
    });
};

